import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import {
  BlueFlagIcon,
  GreenFlagIcon,
  GreyFlagIcon,
  RedFlagIcon,
} from "../../../assets/images";
import { JobTrackerListingType } from "../../../redux/listing/listingTypes";
import { GovtOfficerJobsListType, LoginResponseType } from "../../../redux/auth/authTypes";
type AppProps = {
  jobData: JobTrackerListingType[] | GovtOfficerJobsListType[];
  tableHeader: TableHeadersType[];
  handleSetJobsData?: (data: any, type: string) => void;
  handleToggleProgressCommentsModal?: () => void;
  handleToggleLinkUploadModal?: () => void;
  isAdminReport?: boolean;
  isSuperAdmin?: boolean;
  shareJobList?: boolean;
  getJobId?: any;
  type?: string;
  tab?: string;
  handleChecklistModal?: (data: JobTrackerListingType) => void;
  getShareJobId?: (id: number) => void;
  handleToggleShareJobModal?: () => void;
  jobApprovalPending?: boolean;
  handleSentJobForClosuring?: (data: any) => void;
  handleApproveAndSendModal?: (data: any) => void;
  loginData?: LoginResponseType | undefined;
};
const JobPendingApprovalTableData = ({
  jobData,
  tableHeader,
  isAdminReport,
  isSuperAdmin,
  getJobId,
  type,
  shareJobList,
  loginData,
  tab,
  handleChecklistModal,
  getShareJobId,
  handleToggleShareJobModal,
  handleSetJobsData,
  handleToggleProgressCommentsModal,
  handleToggleLinkUploadModal,
  jobApprovalPending,
  handleSentJobForClosuring,
  handleApproveAndSendModal,
}: AppProps) => {
  const getStatusStyle = (status: any) => {
    switch (status) {
      case 0:
        return notStartedStyle();
      case 1:
        return awaitingApprovalStyle();
      case 2:
        return reworkRequestedStyle();
      case 3:
        return sendForApprvalTypeStyle();
      default:
        return {};
    }
  };
  const sendForApprvalTypeStyle = () => {
    return {
      padding: "4px 10px",
      color: "#82b01f",
      background: "#e7f0d4",
      borderRadius: "16px",
    };
  };
  const awaitingApprovalStyle = () => {
    return {
      background: "#faedd8",
      borderRadius: "16px",
      padding: "4px 10px",
      color: "#f3a119",
    };
  };
  const reworkRequestedStyle = () => {
    return {
      background: "#fde0d3",
      borderRadius: "16px",
      padding: "4px 10px",
      color: "#e7733e",
    };
  };
  const notStartedStyle = () => {
    return {
      background: "#d7e0f1",
      borderRadius: "16px",
      padding: "4px 10px",
      color: "#262a44",
    };
  };
  return (
    <>
      {jobData &&
        jobData?.length > 0 &&
        jobData?.map((itemData: any) => {
          const jobDetails = `${itemData?.job_id}_${itemData?.job_type}_${itemData?.period_ended}`;

          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value === "job_type") {
                  return (
                    <td onClick={() => getJobId?.(itemData)}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "start",
                          gap: "7px",
                        }}
                      >
                        <span
                          className={type == "underline" ? "jobTypeTd" : ""}
                          style={
                            type === "underline"
                              ? {
                                  textDecoration: "underline",
                                  fontWeight: "600",
                                }
                              : {}
                          }
                        >
                          {jobDetails}
                        </span>
                        <span>
                          {itemData?.job_priority === "normal" ? (
                            <img src={GreyFlagIcon} alt="grey" />
                          ) : itemData?.job_priority === "red" ? (
                            <img src={RedFlagIcon} alt="red" />
                          ) : itemData?.job_priority === "green" ? (
                            <img src={GreenFlagIcon} alt="green" />
                          ) : itemData?.job_priority === "blue" ? (
                            <img src={BlueFlagIcon} alt="blue" />
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    </td>
                  );
                } else if (item?.value == "client_code") {
                  return (
                    <td>{`${itemData?.client_name}(${itemData?.client_code})`}</td>
                  );
                } else if (item?.value == "target_end_date") {
                  return <td>{itemData?.target_end_date}</td>;
                } else if (item.value === "job_details") {
                  return <td>{itemData?.job_description}</td>;
                } else if (item.value === "internal_status") {
                  return (
                    <td className="text-center" style={{ minWidth: "190px" }}>
                      <div style={getStatusStyle(itemData?.internal_status)}>
                        {itemData?.internal_status === 0
                          ? "Not Started"
                          : itemData?.internal_status === 1
                          ? "Awaiting Approval"
                          : itemData?.internal_status === 2
                          ? "Rework Requested"
                          : itemData?.internal_status === 3
                          ? "Sent for Closure"
                          : ""}
                      </div>
                    </td>
                  );
                } else if (item.value === "job_manager") {
                  return (
                    <td
                      style={{ width: "100px" }}
                    >{`${itemData?.job_manager?.first_name} ${itemData?.job_manager?.last_name}`}</td>
                  );
                } else if (item.value === "currently_responsible") {
                  return (
                    <td style={{ width: "100px" }}>
                      {`${itemData?.currently_responsible?.first_name} ${itemData?.currently_responsible?.last_name}`}
                    </td>
                  );
                } else if (item.value === "action") {
                  return (
                    <td>
                      <div
                        className="d-flex justify-content-center"
                        style={{ width: "190px" }}
                      >
                        {tab === "jobsPendingApproval" && (
                          <button
                            className="btn btn-primary"
                            onClick={() =>
                              handleApproveAndSendModal?.(itemData)
                            }
                          >
                            Approve or Reject
                          </button>
                        )}
                      </div>
                    </td>
                  );
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default JobPendingApprovalTableData;
